import ClientService from '../../services/client-service';
import getAssetListDataQuery from '../../graphql/query/get-asset-list-data.graphql';
import getAssetDataQuery from '../../graphql/query/get-asset-data.graphql';
import deleteAssetListMutation from '../../graphql/mutation/delete-asset-list.graphql';
import deletePortfolioMutation from '../../graphql/mutation/delete-portfolio.graphql';
import saveAssetListDataMutation from '../../graphql/mutation/save-asset-list-data.graphql';
import savePortfolioOrderSettingsMutation from '../../graphql/mutation/save-portfolio-order-settings.graphql';

export default class AssetListApi {
  public static getAssetListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getAssetListDataQuery, payload);
  }

  public static getAssetData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getAssetDataQuery, payload);
  }

  public static deleteAssetList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteAssetListMutation, payload);
  }

  public static deletePortfolio(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deletePortfolioMutation, payload);
  }

  public static saveAssetListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveAssetListDataMutation, payload);
  }

  public static savePortfolioOrderSettings(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(savePortfolioOrderSettingsMutation, payload);
  }
}
